export const saveSelectedPlant = (state = {}, action) => {
    switch (action.type) {
        case "SAVESELECTEDPLANT": {
            state[action.payload.InsIden] = action.payload;
            return state;
        }
        default:
            return state;
    }
}

export const saveSelectedMachineType = (state = {}, action) => {
    switch (action.type) {
        case "SAVESELECTEDMACHINETYPE": {
            state[action.payload.InsIden] = action.payload;
            return state;
        }
        default:
            return state;
    }
}

export const saveSelectedLine = (state = {}, action) => {
    switch (action.type) {
        case "SAVESELECTEDLINE": {
            state[action.payload.InsIden] = action.payload;
            return state;
        }
        default:
            return state;
    }
}

export const saveSelectedMachine = (state = {}, action) => {
    switch (action.type) {
        case "SAVESELECTEDMACHINE": {
            state[action.payload.InsIden] = action.payload;
            return state;
        }
        default:
            return state;
    }
}

export const saveSelectedShift = (state = {}, action) => {
    switch (action.type) {
        case "SAVESELECTEDSHIFT": {
            state[action.payload.InsIden] = action.payload;
            return state;
        }
        default:
            return state;
    }
}

export const saveSelectedShiftDate = (state = {
    quality: {
        selectedOption: {
            value: new Date(),
        }
    },
    downtime: {
        selectedOption: {
            value: new Date(),
        }
    }
}, action) => {
    switch (action.type) {
        case "SAVESELECTEDSHIFTDATE":
            state[action.payload.InsIden] = action.payload;
            return state;
        default:
            return state;
    }
}


export const timings = (state = {}, action) => {    
    switch (action.type) {        
        case "START_TIME": {
            if(state[action.payload.InsIden]==undefined){
                state[action.payload.InsIden] = {"startTime":action.payload.selectedOption.value};
            }else{
                state[action.payload.InsIden]["startTime"] = action.payload.selectedOption.value;
            }
            return state;
        }

        case "END_TIME": {
            if(state[action.payload.InsIden]==undefined){
                state[action.payload.InsIden] = {"endTime":action.payload.selectedOption.value};
            }else{
                state[action.payload.InsIden]["endTime"] = action.payload.selectedOption.value;
            }
            return state;
        }

        default:
            return state;
    }
}